/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Youtube_Region_8Inputs */



/**
* | output |
* | --- |
* | "Bottom center" |
*
* @param {Live_Caption_Youtube_Region_8Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_youtube_region_8 = /** @type {((inputs?: Live_Caption_Youtube_Region_8Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Youtube_Region_8Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("centre inférieur")
	if (locale === "de") return /** @type {LocalizedString} */ ("Mitte unten")
	if (locale === "it") return /** @type {LocalizedString} */ ("In basso al centro")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Нижний центр")
	if (locale === "es") return /** @type {LocalizedString} */ ("Parte inferior central")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("底部中心")
	if (locale === "ja") return /** @type {LocalizedString} */ ("下中央")
	if (locale === "hi") return /** @type {LocalizedString} */ ("निचला बीच का")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Centro inferior")
	return /** @type {LocalizedString} */ ("Bottom center")
});